<template>
    <div class="w-full">
        <custom-simple-select
            v-if="enabled"
            v-model="option"
            class="w-full min-w-full"
            label="Lugar a donde redirigirá el banner"
            :options="entityOptions"
            @change="onInput"
        />
        <div v-else>
            <custom-input
                v-model="value"
                class="w-full"
                label="Entidad"
                disabled
            />
        </div>
    </div>
</template>

<script>
import { bannerEntitiesPaths } from "@/common/fields/entities-paths";

import CustomInput from "@/components/utils/CustomInput.vue";
import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "BannerEntitySelector",
    components: {
        CustomSimpleSelect,
        CustomInput
    },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        itemCurrent: {
            type: String,
            default: () => "undefined",
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["input"],
    data: () => ({
        option: "custom",
        value: Object.values(bannerEntitiesPaths)[0],
        $enabledOptions: bannerEntitiesPaths
    }),
    computed: {
        entityOptions() {
            return Object.entries(this.$data.$enabledOptions).map(
                ([key, item]) => ({ label: item, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput(value) {
            this.value = bannerEntitiesPaths[value];
            this.$emit("input", value);
        },
        setInput(value) {
            this.option = value;
            this.value = bannerEntitiesPaths[value];
        }
    }
};
</script>
